import { createContext } from 'react'

export type EditWithPreviewContextValue = {
  previewContainer: HTMLDivElement | null
}

export const EditWithPreviewContext =
  createContext<EditWithPreviewContextValue>({
    previewContainer: null,
  })
